import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../common/Navbar.jsx";
import Footer from "../common/Footer.jsx";

const ClientProfile = () => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    telephone: "",
    adresse: "",
    profilepicture: "",
  });
  const [newProfilePicture, setNewProfilePicture] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      navigate("/client/login");
      return;
    }

    const user = JSON.parse(userData);
    setProfileData(user);
    if (user.profilepicture) {
      setImagePreview(
        `${import.meta.env.VITE_API_URL}/${user.profilepicture}`
      );
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewProfilePicture(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("clientToken");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const formDataToSend = new FormData();

      // Append all text fields except password
      Object.keys(profileData).forEach((key) => {
        if (key !== "password" && key !== "profilepicture") {
          formDataToSend.append(key, profileData[key]);
        }
      });

      // Append new profile picture if selected
      if (newProfilePicture) {
        formDataToSend.append("profilepicture", newProfilePicture);
      }

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/clients/${profileData.id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      if (response.ok) {
        const updatedData = await response.json();
        localStorage.setItem("userData", JSON.stringify(updatedData));
        setSuccessMessage("Profile updated successfully!");
        setIsEditing(false);
        // Update profile data with new values
        setProfileData(updatedData);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Failed to update profile");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setError("An error occurred while updating your profile");
    }
  };

  return (
    <>
      <Navbar />
      <div className="seller-form-container">
        <h2>My Profile</h2>
        {error && <div className="error-message">{error}</div>}
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}

        <div className="profile-header">
          <div className="profile-picture-container">
            <img
              src={imagePreview || "../images/default-profile.png"}
              alt="Profile"
              className="profile-picture"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            {isEditing && (
              <div className="form-group">
                <label htmlFor="profilepicture">Change Profile Picture</label>
                <input
                  type="file"
                  id="profilepicture"
                  name="profilepicture"
                  onChange={handleImageChange}
                  accept="image/*"
                />
              </div>
            )}
          </div>

          {!isEditing && (
            <button
              className="edit-btn btn1"
              onClick={() => setIsEditing(true)}
            >
              Edit Profile
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstname">First Name</label>
              <input
                type="text"
                id="firstname"
                name="firstname"
                value={profileData.firstname}
                onChange={handleInputChange}
                disabled={!isEditing}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastname">Last Name</label>
              <input
                type="text"
                id="lastname"
                name="lastname"
                value={profileData.lastname}
                onChange={handleInputChange}
                disabled={!isEditing}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={profileData.username}
              onChange={handleInputChange}
              disabled={!isEditing}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={profileData.email}
              onChange={handleInputChange}
              disabled={!isEditing}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="telephone">Telephone</label>
            <input
              type="tel"
              id="telephone"
              name="telephone"
              value={profileData.telephone}
              onChange={handleInputChange}
              disabled={!isEditing}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="adresse">Address</label>
            <input
              type="text"
              id="adresse"
              name="adresse"
              value={profileData.adresse}
              onChange={handleInputChange}
              disabled={!isEditing}
              required
            />
          </div>

          {isEditing && (
            <div
              className="button-group"
              style={{ display: "flex", gap: "10px" }}
            >
              <button type="submit" className="submit-btn">
                Save Changes
              </button>
              <button
                type="button"
                className="cancel-btn"
                onClick={() => {
                  setIsEditing(false);
                  setError("");
                  setSuccessMessage("");
                  // Reset any changes
                  const userData = JSON.parse(localStorage.getItem("userData"));
                  setProfileData(userData);
                  setNewProfilePicture(null);
                  if (userData.profilepicture) {
                    setImagePreview(
                      `${import.meta.env.VITE_API_URL}/${userData.profilepicture}`
                    );
                  }
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </form>
      </div>
      <Footer />
    </>
  );
};

export default ClientProfile;
